import * as React from 'react';
import { Form } from 'semantic-ui-react';

const dias = [5, 10, 15, 20, 25, 30];

export interface Datos {
    diaPago: number;
    fechaPrimerPago: string;
}

export const inicial: Datos = {
    diaPago: 5,
    fechaPrimerPago: '',
};

interface Props {
    fechaPago: Datos;
    onChange(fechaPago: Datos): void;
}

const FechaPago: React.FunctionComponent<Props> = props => {
    const fechasPagoOptions = dias.map(dia => ({
        key: dia,
        value: dia,
        text: `${dia} de cada mes`,
    }));

    const { fechaPago, onChange } = props;

    return (
        <Form.Group widths='equal'>
            <Form.Select
                label='Día de pago'
                options={fechasPagoOptions}
                value={fechaPago.diaPago}
                onChange={(_e, { value }) => {
                    onChange({ ...fechaPago, diaPago: value as number });
                }}
            />
            <Form.Input
                required
                label='Fecha del primer pago'
                type='date'
                value={fechaPago.fechaPrimerPago}
                onChange={(_e, { value }) => {
                    onChange({ ...fechaPago, fechaPrimerPago: value || '' });
                }}
            />
        </Form.Group>
    );
};

export default FechaPago;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/FechaPago.tsx